module.exports = __webpack_public_path__ + "6e8772cde2972cffb91763299018b109.svg";